import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {catchError, retry, throwError, timer} from "rxjs";
import {inject} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LoggerService} from "../../services/logger/logger-service/logger.service";

const RETRIES = 3; // number of times a failed request will retry
const DELAY_BASE = 2; // delay will be 2^1, 2^2, 2^3 seconds
const ONE_SECOND = 1000;
const NOTIFICATION_DURATION = 10000; // milliseconds
const USER_ERROR_CODE = '4'; // user error prefix (e.g. 401 unauthorised, 404 not found)

/*
 * Handles all HTTP errors in the application.
 * Retries failed request with exponential backoff before throwing error and displaying snackbar.
 * Error is rethrown to be handled by the view.
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);
  const logger = inject(LoggerService);

  logger.debug('HTTP request intercepted.')

  return next(req).pipe(
    retry({
      count: RETRIES,
      delay: (error: HttpErrorResponse, retryCount: number) => {

        // Only retry if 500 (server level) error
        if (error.status.toString()[0] === USER_ERROR_CODE) {
          return throwError(() => error);
        }

        const delay = Math.pow(DELAY_BASE, retryCount) * ONE_SECOND;
        logger.warn(`Failed request. Attempt ${retryCount + 1} of ${RETRIES + 1} commencing in ${delay / ONE_SECOND} seconds.`);
        return timer(delay);
      }
    }),
    catchError(error => {
      logger.error('HTTP Error Handler caught exception', error.message);

      snackBar.open(`Network error: ${error.message}`, 'close', {
        duration: NOTIFICATION_DURATION,
        politeness: "assertive",
        horizontalPosition: "end",
        verticalPosition: "top"
      });

      return throwError(() => error);
    })
  );
};
